import { PageType } from ".";

export default (name: string, adTypeId: number, pageType: PageType): string => {
  const showPlusEssentialsAd3 = adTypeId === 13;
  const showPlusEssentialsAd5 = adTypeId > 22;
  const isHomePage = pageType === "Home";
  let trackingName = "";

  if (showPlusEssentialsAd3) {
    return isHomePage
      ? "homepage-plus-essentials"
      : "myaccount-dashboard-plus-essentials";
  }

  if (showPlusEssentialsAd5) {
    trackingName = isHomePage
      ? "plus-essentials-5-hp"
      : "plus-essentials-5-myaccount-dashboard";
    if (adTypeId === 23) return `${trackingName}-fb`;
    if (adTypeId === 24) return `${trackingName}-disposables`;
    if (adTypeId === 25) return `${trackingName}-janitorial`;
  }

  switch (name) {
    case "non-dairy milk":
      trackingName = "non-dairy";
      break;
    case "spreads":
      trackingName = "spreads";
      break;
    case "flavoring syrups":
      trackingName = "syrups";
      break;
    default:
      trackingName = name.replace(" ", "-");
      break;
  }

  return pageType === "Home"
    ? `hp-plus-essentials-${trackingName}`
    : `myaccount-dashboard-plus-essentials-${trackingName}`;
};
